<template>
	<row-object-page :src-type="SrcType.EVENT" name="event" v-model="event" :force-info="true" @edit="doEdit" @create="doCreate" @replace="doReplace" ref="rowObject"></row-object-page>
</template>

<script setup lang="ts">
import {ref, computed, provide} from "vue";
import RowObjectPage from "@/pages/row-object/RowObjectPage.vue";
import {SrcType} from "@t/meta/SourceType.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import {SideMenu} from "@t/ui/Menu.ts";
import type { Event} from "@t/event/Event.ts";
import {injectEnv} from "@fd/Environment.ts";
import {hasAccess, isSecured} from "@t/security/ObjectAccess.ts";

const ns = useNavigationStore();
const env = injectEnv();

const event = ref<Event>(null);
const rowObject = ref<InstanceType<typeof RowObjectPage> | null>(null);

function doReplace() {
	ns.replaceWith("/editEvent.do", { id: event.value.id }, event.value.subject);
}

function doEdit() {
	editInits();
}

function doCreate() {
	ns.setEmptyMenu();
	ns.forward(env.msg('title.createEvent'));
}

function editInits() {
	ns.setSideMenu(() => {
		const mb = ns.menuBuilder(rowObject.value.getContext());
		const menu:SideMenu = { groups: [] };
		menu.groups.push(mb.newRecordGroup(SrcType.EVENT, event.value?.id));
		const tools = mb.menuGroup("menu_tools", "menu.title.tools");
		tools.items.push(mb.navItem("seeThis", "see.do?id="+event.value?.id+"&type="+SrcType.EVENT, "menu.seeThis", "eye-eyebrow"));
		if (hasAccess(event.value, "delete")) {
			tools.items.push(mb.navItem("moveEvent", "planEvent.do?parentEvent="+event.value.id, "menu.moveEvent", "replan"));
			tools.items.push(mb.confirmDelete(mb.navItem("deleteEvent", "deleteEvent.do?id="+event.value.id, "menu.deleteEvent", "trash"), "menu.deleteEvent.confirm"));
		}
		menu.groups.push(tools);

		const prints = mb.menuGroup("menu_prints", "menu.title.prints");
		prints.items.push(mb.navItem("outputParams", "outputParams.do?descriptor=2&&pk=" + event.value.id + "&section="+ns.activeSection, "title.printEvent", "printer"));
		menu.groups.push(prints);
		return menu;
	}, null, true);
	ns.forward(event.value.subject);
}
</script>

<style>

</style>